export const environment = {
  production: false,
  register_per_page: 10,
   api_url: 'https://hrm-centralizado-back.sigei.gob.do/api',
  api_lobby: 'https://lobby.sigei.gob.do/api',
  api_doc: 'https://xdms-centralizado.sigei.gob.do/api',
  lobbyUrl: 'https://sigei.gob.do/',
  copyright_footer: `Copyright © Instituto Tecnológico de las Américas 2023`,
};
